<template>
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="经销商">
        <Delar></Delar>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="门店">
        <Store></Store>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  import {  } from "@ant-design/icons-vue";
  import { ref,inject } from "vue";
  import Delar from './components/delar';
  import Store from './components/store';
  export default {
    components: { Store, Delar },
    setup() {
      const activeKey = ref(1);
      const $router = inject("$router");
      return {
        activeKey
      };
    },
  };
</script>